

import * as api from '../api';

const OPEN_PRIMARY_CONTACT_DIALOG = "OPEN_PRIMARY_CONTACT_DIALOG";
const CLOSE_PRIMARY_CONTACT_DIALOG = "CLOSE_PRIMARY_CONTACT_DIALOG";


const initialState = {
  primaryContactDialogOpen: false,
  organisationName: '',
  primaryContactName: '',
  primaryContactNumber: '',
  primaryContactEmail: '',
};

export default (state = initialState, action) => {
  switch (action.type) {

    case OPEN_PRIMARY_CONTACT_DIALOG:
      return {
        ...state,
        primaryContactDialogOpen: true,
        organisationName: action.payload.organisation_name,
        primaryContactName: action.payload.primary_contact_name,
        primaryContactNumber: action.payload.primary_contact_number,
        primaryContactEmail: action.payload.primary_contact_email,
      };

    case CLOSE_PRIMARY_CONTACT_DIALOG:
      return {
        ...state,
        primaryContactDialogOpen: false,
        organisationName: '',
        primaryContactName: '',
        primaryContactNumber: '',
        primaryContactEmail: '',
      };

    default:
      return state;
  }
};



// open the forgot password dialog
export const openPrimaryContactDialog = (data) => {
  return dispatch => {
    dispatch({
      type: OPEN_PRIMARY_CONTACT_DIALOG,
      payload: data,
    });
  };
};

// Close the forgot password dialog
export const closePrimaryContactDialog = () => {
  return dispatch => {
    dispatch({ type: CLOSE_PRIMARY_CONTACT_DIALOG });
  };
};



// WEBPACK FOOTER //
// ./src/modules/app.js